export default __webpack_public_path__ + "static/SubpageBanners_TheNextStep-7ad54b0a1d8a14b65fd5354f4fba56df.jpg";